module.exports = "/_next/static/images/3b42ecd81a9ff73cd043389b68a692fd-mgm-xs-2x.jpg.webp";